import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import IconSelect from "../../../../components/select/main/icon/IconSelect";
import {
  StyledCard,
  StyledCardBody,
  StyledCardHeader,
} from "../../../../styles/CardStyles";
import {
  StyledFlexColumn,
  StyledFlexRow,
} from "../../../../styles/LayoutStyles";
import { useLanguageContext } from "../../../../context/LanguageContext";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { StyledFixedValue } from "../mapping/field/AzureFieldMappingsStyles";
import { StyledInput } from "../../../../styles/InputStyles";
import { StyledAltIconButton } from "../../../../styles/ButtonStyles";

function AzureRolesView({
  rolesData,
  availableRoles,
  onAddRole,
  onDeleteRole,
  onAzureGroupIdChange,
  formId,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="azure_configs_page_fetch">
      <StyledCard>
        <StyledCardHeader>
          <StyledFlexRow
            style={{
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 style={{ flex: 1 }}>{translate("eva.main.entities.roles")}</h2>

            {/* Field mapping add button */}
            <IconSelect
              options={availableRoles.map((role) => ({
                value: role.id,
                label: role.name,
              }))}
              icon={() => <FontAwesomeIcon icon={faPlus} />}
              style={{ marginLeft: "auto" }}
              onChange={(value) => onAddRole(value)}
              disabled={availableRoles.length <= 0}
            />
          </StyledFlexRow>
        </StyledCardHeader>

        <StyledCardBody>
          <StyledFlexColumn>
            {rolesData.map((dataRole) => (
              <StyledFlexRow
                key={dataRole.role_id}
                style={{
                  alignItems: "center",
                  flexWrap: "nowrap",
                }}
              >
                <StyledFixedValue style={{ flex: 1 }}>
                  {dataRole.role?.name || dataRole.role_id}
                </StyledFixedValue>

                <StyledInput
                  form={formId}
                  placeholder={translate(
                    "eva.main.validation.attributes.azure_group_id",
                  )}
                  value={dataRole.azure_group_id}
                  onChange={(e) =>
                    onAzureGroupIdChange(dataRole.role_id, e.target.value)
                  }
                  style={{ flex: 1 }}
                />

                <StyledAltIconButton
                  onClick={() => onDeleteRole(dataRole.role_id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </StyledAltIconButton>
              </StyledFlexRow>
            ))}
          </StyledFlexColumn>
        </StyledCardBody>
      </StyledCard>
    </OverlayLoader>
  );
}

export default AzureRolesView;
